import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { MESSAGES } from '../../../constants/constants.js';


const Ipwhitelisting = (props) => {
  const { register, reset, getValues, setValue, formState: { errors } } = useForm();
  const [ipArr, setIpArr] = useState([]);
  const [ipValue, setIpValue] = useState('');

  // Options for the Select dropdown
  const ipArrOptions = ipArr.map(ip => ({ label: ip, value: ip }));

  // Handler for adding an IP
  const addIp = (event) => {
    event.preventDefault();
    if (!ipValue) {
      toast.error("Please enter IP address.");
      return;
    }
    if (validateIp(ipValue)) {
      const ips = ipValue.split(',').map(ip => ip.trim()).filter(Boolean);
      setIpArr([...ipArr, ...ips]);
      setIpValue('');
      reset({ ipValue: '' });
    }
  };

  // Validation for IP
  const validateIp = (value) => {
    const regex = /^(\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b|\b(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\b)(,\s*(\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b|\b(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\b))*$/;
    if (!regex.test(value)) {
      toast.error("Invalid IP format. Enter valid IPs separated by commas.");
      return false;
    }
    return true;
  };

  // Handler for removing all IPs
  const removeIp = () => {
    setIpArr([]);
    reset({ ipValue: '' });
  };

  // Handler for Select component changes
  const handleSelectChange = (selectedOptions) => {
    const updatedIps = selectedOptions.map(option => option.value);
    setIpArr(updatedIps);
  };

  return (
    <>
      <Modal {...props}>
        <Modal.Header closeButton>
          <Modal.Title>Add IP Whitelisting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <form>
              <div>
              <p>Please enter comma-separated IP addresses (supports IPv4 and IPv6).</p>
                  <textarea
                    {...register('ipValue', {
                      required: 'IP address is required',
                      pattern: {
                        value: /^(\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b|\b(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\b)(,\s*(\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b|\b(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\b))*$/,
                        message: "Enter valid IPs, separated by commas if multiple (IPv4 or IPv6 format)"
                      }
                    })}
                    className="form-control"
                    value={ipValue}
                    style={{height:'65px'}}
                    onChange={(e) => setIpValue(e.target.value)}
                    placeholder="IP Address"
                  />
                
             
                <div style={{ marginBottom: '4px' }}>
                  {errors.ipValue && <span style={{ color: 'red' }}>{errors.ipValue.message}</span>}
                </div>
                <div style={{marginTop:'10px'}}>
                <button
                  type="button"
                  onClick={addIp}
                  className="btn btn-success modal__button"
                  style={{ color: 'white', backgroundColor: '#65c5ff', border: '1px solid #65c5ff', fontSize: '13px' }}
                >
                  Add IP
                </button>
                <button
                  type="button"
                  onClick={removeIp}
                  className="btn btn-danger modal__button"
                  style={{ color: 'white', fontSize: '13px', marginLeft: '9px' }}
                >
                  Remove IP
                </button>
               </div>
              </div>
            </form>
            <div style={{ marginTop: '14px' }}>
              <Select
                id="select2"
                isDisabled={!ipArr.length}
                options={ipArrOptions}
                value={ipArrOptions.filter(option => ipArr.includes(option.value))}
                placeholder="Please add IP address..."
                isMulti
                onChange={handleSelectChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={() => {
            if (!ipArr.length) {
              toast.error('Please add at least one IP address.');
              return;
            }
            props.onSubmit(ipArr);
          }}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Ipwhitelisting;
